export class StringBuffer {
	private buffer: string[] = new Array();

	public append(str: string) {
		this.buffer.push(str);
	}

	public toString() {
		return this.buffer.join('');
	}
}



// WEBPACK FOOTER //
// ./src/logic/scorm/impl/legacy/stringBuffer.ts